import styled from "styled-components";

export const StyledPosts = styled.div`
	#posts {
		display: flex;
		flex-direction: column;
		align-items: center;
		row-gap: 3.5rem;
	}
`;
